import React from 'react'
import { MoonLoader } from 'react-spinners';

const SpinnerLoading = () => {
    return (
        <div className='spinner-loading'>
            <div className='spinner-loading-content'>
                <MoonLoader color="#0033AD" />
            </div>

        </div>
    )
}

export default SpinnerLoading